// extracted by mini-css-extract-plugin
export default {"inputTextarea":"Textarea_inputTextarea__tph7L"};